export const DateRange = {
  Start: "start" as const,
  End: "end" as const,
}

export const NumberRange = {
  Highest: "highest" as const,
  Lowest: "lowest" as const,
}

export const FilterWithDateRange = {
  YearMonthRange: "yearMonthRange" as const,
}

export const Email = {
  To: "to" as const,
  Subject: "subject" as const,
  Message: "message" as const,
}

export const CostForwardingMarking = {
  CostForwardingAvailable: "costForwardingAvailable" as const,
  CostForwardingState: "costForwardingState" as const,
  CostForwardingCustomer: "costForwardingCustomer" as const,
  CostForwardingDescription: "costForwardingDescription" as const,
  CostForwardingSavedCustomerId: "costForwardingSavedCustomerId" as const,
  CostForwardingSavedDescription: "costForwardingSavedDescription" as const,
}

